<script>
import redactor from "../../components/form/redactor.vue";

export default {
  name: "emailSignature",
  components: {
    redactor,
  },
  data() {
    return {};
  },
  mounted: async function () {
    this.$refs.emailSig.setTextBody(await this.$A.UserService.GetSignature());
  },
  methods: {
    updateEmailSignature: async function () {
      let textBody = this.$refs.emailSig.getTextBody();
      await this.$A.UserService.UpdateUserEmailSignature(
          this.$A.Auth.id,
          textBody
      );
    },
  },
};
</script>

<template>
  <div class="settings-card">
    <div class="card-head">
      <div class="card-head-title">Email Signature</div>
      <div class="card-head-subtitle">Replace the default signature with your own — it appears at the bottom of the emails Ashore sends for you.</div>
    </div>
    <div class="card-body">
      <redactor ref="emailSig" data-cy="emailSignatureInput"/>
    </div>
    <div class="card-foot">
      <a class="primary-btn" @click="updateEmailSignature" data-cy="updateSignatureBtn">Update</a>
    </div>
  </div>
</template>

<style scoped>
.settings-card {
  background: #fff;
  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(8, 11, 13, 0.04), 0 8px 24px -16px rgba(8, 11, 13, 0.1);
}
.card-head {
  padding: 14px 20px;
  background: #fbfbfc;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px 12px 0 0;
}
.card-head-title {
  font-size: 15px;
  font-weight: 600;
  color: #111827;
}
.card-head-subtitle {
  margin-top: 1px;
  font-size: 12.5px;
  font-weight: 400;
  color: #6b7280;
}
.card-body {
  padding: 20px;
}
.card-foot {
  display: flex;
  justify-content: flex-end;
  padding: 12px 20px;
  background: #fbfbfc;
  border-top: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 0 0 12px 12px;
}
.primary-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 18px;
  background: #019256;
  color: #fff;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  transition: background-color 120ms ease;
}
.primary-btn:hover {
  background: #017a48;
  color: #fff;
  text-decoration: none;
}
@media (max-width: 575px) {
  .primary-btn {
    width: 100%;
  }
}
</style>
